import Switch from '@carvana/switch'; // TODO Replace with latest Showroom
import styled from 'styled-components';

export const StyledSwitch = styled(Switch).attrs({
  className: '!flex !h-[44px] mx-auto z-0'
})`
  div {
    align-self: center;

    &:first-child {
      height: 40px;
    }
  }
`;
